/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface DanceListItem
 */
export interface DanceListItem {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceListItem
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof DanceListItem
     */
    name: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceListItem
     */
    seasonId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceListItem
     */
    choreographerUserId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof DanceListItem
     */
    choreographerName: string;
    /**
     * 
     * @type {boolean}
     * @memberof DanceListItem
     */
    isArchived: boolean;
    /**
     * 
     * @type {Date}
     * @memberof DanceListItem
     */
    lastActivityAt: Date | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceListItem
     */
    done: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceListItem
     */
    total: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<string>}
     * @memberof DanceListItem
     */
    missing: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DanceListItem
     */
    driveFileId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DanceListItem
     */
    driveSyncedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DanceListItem
     */
    driveError: string | null;
}

/**
 * Check if a given object implements the DanceListItem interface.
 */
export function instanceOfDanceListItem(value: object): value is DanceListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('seasonId' in value) || value['seasonId'] === undefined) return false;
    if (!('choreographerUserId' in value) || value['choreographerUserId'] === undefined) return false;
    if (!('choreographerName' in value) || value['choreographerName'] === undefined) return false;
    if (!('isArchived' in value) || value['isArchived'] === undefined) return false;
    if (!('lastActivityAt' in value) || value['lastActivityAt'] === undefined) return false;
    if (!('done' in value) || value['done'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('missing' in value) || value['missing'] === undefined) return false;
    if (!('driveFileId' in value) || value['driveFileId'] === undefined) return false;
    if (!('driveSyncedAt' in value) || value['driveSyncedAt'] === undefined) return false;
    if (!('driveError' in value) || value['driveError'] === undefined) return false;
    return true;
}

export function DanceListItemFromJSON(json: any): DanceListItem {
    return DanceListItemFromJSONTyped(json, false);
}

export function DanceListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DanceListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'seasonId': ApiUserTasksGetPageParameterFromJSON(json['seasonId']),
        'choreographerUserId': ApiUserTasksGetPageParameterFromJSON(json['choreographerUserId']),
        'choreographerName': json['choreographerName'],
        'isArchived': json['isArchived'],
        'lastActivityAt': (json['lastActivityAt'] == null ? null : new Date(json['lastActivityAt'])),
        'done': ApiUserTasksGetPageParameterFromJSON(json['done']),
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
        'missing': json['missing'],
        'driveFileId': json['driveFileId'],
        'driveSyncedAt': (json['driveSyncedAt'] == null ? null : new Date(json['driveSyncedAt'])),
        'driveError': json['driveError'],
    };
}

export function DanceListItemToJSON(json: any): DanceListItem {
    return DanceListItemToJSONTyped(json, false);
}

export function DanceListItemToJSONTyped(value?: DanceListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'seasonId': ApiUserTasksGetPageParameterToJSON(value['seasonId']),
        'choreographerUserId': ApiUserTasksGetPageParameterToJSON(value['choreographerUserId']),
        'choreographerName': value['choreographerName'],
        'isArchived': value['isArchived'],
        'lastActivityAt': value['lastActivityAt'] == null ? value['lastActivityAt'] : value['lastActivityAt'].toISOString(),
        'done': ApiUserTasksGetPageParameterToJSON(value['done']),
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
        'missing': value['missing'],
        'driveFileId': value['driveFileId'],
        'driveSyncedAt': value['driveSyncedAt'] == null ? value['driveSyncedAt'] : value['driveSyncedAt'].toISOString(),
        'driveError': value['driveError'],
    };
}

